module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading,
      "color": "#007be8"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "payment-success-container",
    attrs: {
      "id": "permalink-page"
    }
  }, [_c('div', {
    staticClass: "register-container full-height sm-p-t-30",
    staticStyle: {
      "width": "355px"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-center flex-column full-height font-montserrat"
  }, [_c('span', {
    staticClass: "text-right"
  }, [_c('img', {
    staticClass: "cursor",
    attrs: {
      "src": "/static/assets/images/flag/en.png"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('en')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "cursor",
    attrs: {
      "src": "/static/assets/images/flag/fr.png"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('fr')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default transaction-box",
    attrs: {
      "id": "panel-paiement-box"
    }
  }, [_c('div', {
    staticClass: "panel-header panel-product-header text-align-center"
  }, [_c('div', {
    staticClass: "product-details"
  }, [_c('h5', {
    staticClass: "product-name no-margin"
  }, [_vm._v("\n                " + _vm._s(_vm.status === 'success' ? _vm.$t('payments.success.payment_done') : _vm.$t('payments.error.payment_failed')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "product-description"
  }, [_vm._v("\n                " + _vm._s(_vm.status === 'success' ? _vm.$t('payments.success.reservation_confirmed') : _vm.$t('payments.error.reservation_not_confirmed')) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding"
  }, [_c('section', {
    staticClass: "form-section form-card-section",
    attrs: {
      "id": "cardBox"
    }
  }, [_c('p', {
    class: _vm.status == 'success' ? 'success-payment text-align-center' : 'text-align-center error-payment'
  }, [_vm._v("\n                " + _vm._s(_vm.status === 'success' ? _vm.$t('payments.success.captured') :
    _vm.$t('payments.error.captured2')) + "\n              ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "transaction-secured text-align-center"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "footerSecurity"
    }
  }, [_vm._v(_vm._s(_vm.$t("payments.permalink.transaction_secured")) + "\n          ")])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54f96053"}!./src/app/pages/payments/confirm3dsAuthentication/confirm3dsAuthentication.html
// module id = 1351
// module chunks = 0